import React from 'react';
import CoursesDataProvider from '../../Utils/Courses/CoursesDataProvider';
import PropTypes from 'prop-types';
import { RecommendedCoursesContainer } from './EachCourse.styles';
import EachRecommended from './EachRecommendedCourse.component';

const RecommendedCourses = ({ course }) => {
  return (
    <RecommendedCoursesContainer>
      <div>
        <h3 className="m1B">Recommended Courses</h3>
      </div>
      <CoursesDataProvider>
        {(courses) => {
          return <EachRecommended courses={courses} course={course} />;
        }}
      </CoursesDataProvider>
    </RecommendedCoursesContainer>
  );
};
RecommendedCourses.propTypes = {
  course: PropTypes.shape({
    _id: PropTypes.string,
    courseName: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    price: PropTypes.number,
  }),
};
export default RecommendedCourses;
